import { IProjectsState } from '@app/projects/store';
import { IBasicDataState } from '@app/project/modules/basic-data/store';
import { ISettingUpTaxCalculationsState } from '@app/project/modules/setting-up-tax-calculations/store';
import { IMacroparameterSettingsState } from '@app/project/modules/macroparameter-settings/store';
import { ICapitalInvestmentsState } from '@app/project/modules/capital-investments/store';
import { ISalesAndRevenueCalculationState } from '@app/project/modules/sales-and-revenue-calculation/store';
import { ICostCalculationState } from '@app/project/modules/cost-calculation/store';
import { IModelingOfEquityContributionsState } from '@app/project/modules/modeling-of-equity-contributions/store';
import { ILoanModelingState } from '@app/project/modules/loan-modeling/store';
import { ILeasingModelingState } from '@app/project/modules/leasing-modeling/store';
import { IModelingWorkingCapitalState } from '@app/project/modules/modeling-working-capital/store';
import {
  IScenarioState,
} from '@app/project/modules/choice-of-calculation-options/store';
import { IProjectState } from '@shared/model/project';
import { IOption } from '@shared';
import { IUserState } from '@app/layout/store';
import { ICalculationState } from '@app/project/modules/project-calculation/store/main.reducers';
import { IHandbookState } from '@app/side-bar/store/side-bar.reducers';
import {ILanguageState} from "@app/store/reducers/language.reducer";
import { IAccessState } from '@app/access/store/access.reducer';

export interface IRootState {
  access: IAccessState;
  activities: IOption[];
  project: IProjectState;
  projects: IProjectsState;
  user: IUserState;
  language: ILanguageState;
  basicDataState: IBasicDataState;
  settingUpTaxCalculationState: ISettingUpTaxCalculationsState;
  macroparameterSettingsState: IMacroparameterSettingsState;
  capitalInvestmentsState: ICapitalInvestmentsState;
  salesAndRevenueCalculationState: ISalesAndRevenueCalculationState;
  costCalculationState: ICostCalculationState;
  modelingOfEquityContributionsState: IModelingOfEquityContributionsState;
  loanModelingState: ILoanModelingState;
  leasingModelingState: ILeasingModelingState;
  modelingWorkingCapitalState: IModelingWorkingCapitalState;
  calculationScenariosState: IScenarioState;
  calculationState: ICalculationState;
  handbookState: IHandbookState;
}
